import React from 'react';
const AnnounceIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11 5.882V4a2 2 0 012-2h2a2 2 0 012 2v1.882l2.293 2.293a1 1 0 01-.707 1.707H8.414a1 1 0 01-.707-1.707L11 5.882z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11 5.882V18a2 2 0 002 2h2a2 2 0 002-2v-1.118"
    />
  </svg>
);
export default AnnounceIcon;
